import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, requiredPayloadEnvelope } from '../envelope.js';
import { publishedTermSchema, termDocumentDetailSchema, termVersionSchema, } from '../common/schemas.js';
const c = initContract();
/** user-api — 게시된 약관 조회·버전 이력. 동의 제출은 auth 계약의 acceptances를 쓴다. */
export const userTermsContract = c.router({
    /** 현재 사용자에게 적용되는 게시 약관 목록을 조회한다. */
    getCurrent: {
        method: 'GET',
        path: '/terms/current',
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 필수·선택 포함 게시 약관 목록이다. */
                terms: z.array(publishedTermSchema),
            })),
            ...commonErrorResponses,
        },
    },
    /** 약관 문서 id로 본문을 포함한 상세를 조회한다. */
    getDocument: {
        method: 'GET',
        path: '/terms/documents/:id',
        pathParams: z.object({
            /** TermDocument id다. */
            id: z.string(),
        }),
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 본문·재동의 요구 여부를 포함한 문서다. */
                document: termDocumentDetailSchema,
            })),
            ...commonErrorResponses,
        },
    },
    /** 한 약관 type의 게시 버전 이력을 조회한다. */
    listVersions: {
        method: 'GET',
        path: '/terms/:type/versions',
        pathParams: z.object({
            /** 약관 종류 키다. */
            type: z.string(),
        }),
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 게시된 버전 메타 목록이다. 본문은 포함하지 않는다. */
                versions: z.array(termVersionSchema),
            })),
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=terms.contract.js.map